/*
  SearchFilter

  El search filter tiene un input pero quiero que funcione como los filtros.
  Cuando esta vacio tiene que tener la clase .empty (en el className).
  Cuando el input no esta vacio hay que sacar la clase .empty para que adquiera los estilos similares a cuando hay un filtro activo.
  Lo que estaría bueno es que cuando hagas hover sobre el componente se ponga en focus el input (como si clickearas en el input).

*/
import React from "react";
import { connect } from "react-redux";
import { filterStock } from "actions/stock";
import "./styles.scss";

class SearchFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: "",
    };
  }

  handleInput(e) {
    this.setState({
      searchText: e.target.value,
    });

    this.props.filter("name", e.target.value);
  }

  render() {
    const isEmpty = this.state.searchText ? false : true;

    return (
      <div className={`searchFilter ${isEmpty ? "empty" : ""}`}>
        <div className="placeholder">Buscar por modelo</div>

        <div className="input">
          <input
            type="text"
            onChange={this.handleInput.bind(this)}
            value={this.state.searchText}
            placeholder="Ej: Golf"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    filter: (attribute, value) => {
      dispatch(filterStock(attribute, value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilter);
